import utils from './Util';

export const pageMixin = {
    data: function() {
        return {
            pagination: {
                size: 20,
                total: 0,
                current: 1
            }
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
};

export const fmtMixin = {
    methods: {
        boolFormatter(row, column, cellValue) {
            return cellValue ? (
                <i class="el-icon-success" style="color:#67C23A" />
            ) : (
                <i class="el-icon-error" style="color:#F56C6C" />
            );
        },
        unixFormatter(row, column, cellValue) {
            return utils.unix2datetime(cellValue);
        },
        dateFormatter(row, column, cellValue) {
            if(!cellValue){
                return '-';
            }
            return utils.formatDate(cellValue);
        },
        datetimeFormatter(row, column, cellValue) {
            if(!cellValue){
                return '-';
            }
            return utils.formatDate(cellValue, 'YYYY-MM-DD HH:mm');
        },
        currencyFormatter(row, column, cellValue) {
            let value = cellValue || 0;
            return value ? `￥${value}` : '-';
        },
        yuanFormatter(row, column, cellValue) {
            let value = cellValue || 0;
            return value ? `￥${(value/100).toFixed(2)}` : '-';
        },
        arrayFormatter(row, column, cellValue) {
            if (cellValue) {
                return cellValue.join(', ');
            }
            return '';
        },
        statusFormatter(row, column, cellValue) {
            if (cellValue === -1) {
                return (
                    <el-tag type="danger" size="mini" effect="dark">
                        已拒绝
                    </el-tag>
                );
            }
            if (cellValue === 0) {
                return (
                    <el-tag type="default" size="mini" effect="dark">
                        待审核
                    </el-tag>
                );
            }
            if (cellValue === 1) {
                return (
                    <el-tag type="success" size="mini" effect="dark">
                        已通过
                    </el-tag>
                );
            }
        }
    }
};
